import { Header as HeaderChat } from "@conversation-panel/header";
import { Loader } from "@conversation-panel/loader";
import { ConversationArea } from "@conversation-panel/conversation-area";

import bgImageChatNoTalk from "@assets/images/backgrounds/background-chat-no-talk.png";
import bgImageChatNoPorposes from "@assets/images/backgrounds/background-no-proposes.png";

import { useConversationPanelSection } from "./conversation-panel-section.hook";
import { CONVERSATION_PANEL_STRINGS } from "./utils/conversation-panel-section.constants";
import type { TConversationPanelSectionConfig } from "./conversation-panel-section.types";
import * as S from "./conversation-panel-section.styles";

const ConversationPanelSection = ({
  show,
}: TConversationPanelSectionConfig) => {
  const { hasActiveConversation, shouldShowConversation, welcomeVariant } =
    useConversationPanelSection();

  return (
    <S.ConversationContent data-qa="conversation-panel-section" show={show}>
      <S.Conversation welcome={!hasActiveConversation}>
        {!hasActiveConversation && (
          <>
            {welcomeVariant === "loading" && <Loader type="webmotors" />}
            {welcomeVariant === "withoutConversation" && (
              <>
                <img
                  className="no-conversation"
                  src={bgImageChatNoPorposes}
                  alt={CONVERSATION_PANEL_STRINGS.NO_PROPOSALS_ALT}
                />
                <h4>{CONVERSATION_PANEL_STRINGS.NO_PROPOSALS_HEADING}</h4>
                <p>{CONVERSATION_PANEL_STRINGS.NO_PROPOSALS_TEXT}</p>
              </>
            )}
            {welcomeVariant === "withConversation" && (
              <>
                <img
                  src={bgImageChatNoTalk}
                  alt={CONVERSATION_PANEL_STRINGS.WELCOME_ALT}
                />
                <h4>{CONVERSATION_PANEL_STRINGS.WELCOME_HEADING}</h4>
                <p>{CONVERSATION_PANEL_STRINGS.WELCOME_TEXT}</p>
              </>
            )}
          </>
        )}
        {hasActiveConversation && (
          <>
            <HeaderChat />
            {shouldShowConversation ? (
              <ConversationArea />
            ) : (
              <Loader type="webmotors" />
            )}
          </>
        )}
      </S.Conversation>
    </S.ConversationContent>
  );
};

ConversationPanelSection.displayName = "ConversationPanelSection";
export { ConversationPanelSection };
